"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
function default_1({ roomViewUrl, e, }) {
    if (window.isNativeApp) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        (0, _1.postMessageToWVA)(`ROOMVIEW::${roomViewUrl}`);
    }
    else if (!e) {
        // ? if no mouse event from anchor tag
        window.location.href = roomViewUrl;
    }
    // ? 앱이 아니고 anchor tag의 event이면 anchor tag의 href(기본동작) 실행
}
exports.default = default_1;
